import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as I18n from 'src/utils/i18n';
import { Balloon } from '@alifd/next';
import safeLog from '@alife/bc-safe-log';

// const I18n = i18n.createI18n('companyCardIntegrated');

/**
 * 从美杜莎获取配置化文案
 */
function getPromiseData() {
  try {
    return new Array(6)
      .fill('placeholder')
      .map((_, index) => ({
        logoUrl: I18n.get(
          `companyCardIntegrated.self.promiselist.${index + 1}.logo`,
        ),
        text: I18n.get(
          `companyCardIntegrated.self.promiselist.${index + 1}.text`,
        ),
        balloonText: I18n.get(
          `companyCardIntegrated.self.promiselist.${index + 1}.balloonText`,
        ),
      }))
      .filter(
        textItem => textItem.logoUrl || textItem.text || textItem.balloonText,
      );
  } catch (error) {
    return null;
  }
}

class SelfShopCard extends PureComponent {
  static propTypes = {
    seller: PropTypes.shape({
      homeUrl: PropTypes.string,
      companyLogoFileUrlSmall: PropTypes.string,
      companyName: PropTypes.string,
    }),
  };

  componentDidMount() {
    const so = document.querySelector(
      '.sub-content .card-action-button-self-buy-now',
    );
    so && so.addEventListener('click', this.soBtnDot);
  }

  componentWillUnmount() {
    const so = document.querySelector(
      '.sub-content .card-action-button-self-buy-now',
    );
    so && so.removeEventListener('click', this.soBtnDot);
  }

  soBtnDot = () => {
    safeLog('/sc.details.commonLogs', 'CLK', 'info=&action=selfSoClick', 'GET');
  };

  render() {
    const { seller = {} } = this.props;
    const { homeUrl, companyLogoFileUrlSmall, companyName } = seller;
    const promiseListData = getPromiseData();
    return (
      <div id="seller-self-operated-card">
        <div className="alibaba-shop-card">
          <div className="offical-name-and-photo">
            <img
              src={companyLogoFileUrlSmall}
              alt="avtar"
              className="offical-photo"
            />
            <a className="offical-name" target="_blank" href={homeUrl}>
              {companyName}
            </a>
          </div>
          <div className="split-line" />
          <div className="we-promise">
            {I18n.get('companyCardIntegrated.self.promise')}
          </div>
          <div className="promise-list">
            <ul className="promise-list-ul">
              {promiseListData &&
                promiseListData.map((itemData, index) => {
                  return (
                    <Balloon
                      trigger={
                        <li className="promise-list-li">
                          <img src={itemData.logoUrl} alt="avtar" />
                          <span>{itemData.text}</span>
                        </li>
                      }
                      key={index}
                      closable={false}
                      align="bl"
                      alignEdge
                      offset={[-5, 0]}
                      cache
                      popupContainer={() =>
                        document.querySelector('#seller-self-operated-card')
                      }
                      className="promise-list-li-balloon"
                      style={{
                        maxWidth: '232px',
                        background: '#FAFAFA',
                        color: '#333',
                      }}
                    >
                      {itemData.balloonText}
                    </Balloon>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default SelfShopCard;
